import React from 'react';

import EditNoteIcon from '@mui/icons-material/EditNote';
import { IconButton, Tooltip } from '@mui/material';

import type { ManageRoomRateSurchargesActionProps } from './types';

export default function ManageRoomRateSurchargesAction({ href }: ManageRoomRateSurchargesActionProps) {
  if (!href) {
    return null;
  }

  return (
    <Tooltip title="Manage room-rate surcharges">
      <IconButton
        aria-label="Manage room-rate surcharges"
        color="primary"
        component="a"
        href={href}
        rel="noreferrer"
        size="small"
        target="_blank"
      >
        <EditNoteIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
